// Copied from advisor-3.0/src/components/Layout/Nav.js
// Changes: sessionStorage -> useAccount TanStack hook, clsx -> template literals
import { Box } from '@mui/material';
import UserAvatar from 'src/components/User/UserAvatar';
import { useAccount } from 'src/api/hooks/useAccount';
import { useAdvisor } from 'src/api/hooks/useAdvisor';
import './Nav.scss';

interface NavProps {
  expanded: boolean;
  isSignWithoutAuth?: boolean;
}

export default function Nav({ expanded, isSignWithoutAuth }: NavProps) {
  const { data } = useAccount();

  const { data: advisor } = useAdvisor();

  const logoURL = data?.account?.logoUrl || '/logos/covr-logo.svg';
  const userName = advisor ? `${advisor.firstName} ${advisor.lastName}` : '';

  return (
    <div
      id="advisor-nav"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
      className={`sticky-top ${isSignWithoutAuth ? 'ml-0' : ''} ${expanded ? 'sidebar-open' : 'sidebar-close'}`}
    >
      <img id="partner-logo" alt="partner-logo" src={logoURL} />
      {!isSignWithoutAuth && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Box ml={2} />
          <UserAvatar name={userName} />
        </div>
      )}
    </div>
  );
}
